function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function (_typeof2) { function _typeof(_x) { return _typeof2.apply(this, arguments); } _typeof.toString = function () { return _typeof2.toString(); }; return _typeof; }(function (obj) { return typeof obj; }); } else { _typeof = function (_typeof3) { function _typeof(_x2) { return _typeof3.apply(this, arguments); } _typeof.toString = function () { return _typeof3.toString(); }; return _typeof; }(function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }); } return _typeof(obj); }

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import Component from 'vue-class-component';
import { VueComponent } from '@progress/kendo-vue-common'; // import { DropDownList } from '@progress/kendo-vue-dropdowns';
// import { NumericTextBox } from '@progress/kendo-vue-inputs';
// import { DatePicker } from '@progress/kendo-vue-dateinputs';

import { cellBoolDropdownChange, cellInputChange, cellOperatorChange } from '../filterCommon';
/**
 * @hidden
 */

var GridColumnMenuFilterCell =
/** @class */
function (_super) {
  __extends(GridColumnMenuFilterCell, _super);

  function GridColumnMenuFilterCell() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  GridColumnMenuFilterCell.prototype.created = function () {
    this.inputChange = this.inputChange.bind(this);
    this.operatorChange = this.operatorChange.bind(this);
    this.boolDropdownChange = this.boolDropdownChange.bind(this);
  };

  GridColumnMenuFilterCell.prototype.triggerChange = function (filter) {
    this.$emit('change', filter);
  };
  /**
   * @hidden
   */
  // @ts-ignore


  GridColumnMenuFilterCell.prototype.render = function (h) {
    var _this = this;

    var ddlValue = this.$props.operators.find(function (item) {
      return item.operator === _this.$props.operator;
    }) || null;

    var optionMapper = function optionMapper(items, selected) {
      return items.map(function (item) {
        if (selected && item.operator === selected.operator) {
          return h("option", {
            domProps: {
              "value": item.operator
            },
            attrs: {
              selected: true
            }
          }, [item.text]);
        } else {
          return h("option", {
            domProps: {
              "value": item.operator
            }
          }, [item.text]);
        }
      });
    };

    var filterComponent = function filterComponent(filterType, value, operators) {
      switch (filterType) {
        case 'numeric':
          return (// <NumericTextBox
            //     value={value}
            //     onChange={(e) => { this.inputChange(e.value, e.syntheticEvent); }}
            // />
            h("input", {
              attrs: {
                type: "number"
              },
              "class": "k-textbox",
              domProps: {
                "value": value
              },
              on: {
                "input": function input(e) {
                  _this.inputChange(parseFloat(e.target.value), e);
                }
              }
            })
          );

        case 'date':
          return (// <DatePicker
            //     value={value}
            //     onChange={(e) => { this.inputChange(e.value, e.syntheticEvent); }}
            // />
            h("input", {
              attrs: {
                type: "date"
              },
              "class": "k-textbox",
              domProps: {
                "value": value ? new Date(value).toISOString().substring(0, 10) : value
              },
              on: {
                "input": function input(e) {
                  _this.inputChange(new Date(e.target.value), e);
                }
              }
            })
          );

        case 'boolean':
          var noFilterSet_1 = function noFilterSet_1(filter) {
            return filter === null || filter === undefined;
          }; // return (
          //     <DropDownList
          //         onChange={this.boolDropdownChange}
          //         value={operators.find(item => item.operator === (noFilterSet(value) ? '' : value))}
          //         data={operators}
          //         textField="text"
          //     />
          // );


          var booleanOptions = optionMapper(operators, operators.find(function (item) {
            return item.operator === (noFilterSet_1(value) ? '' : value);
          }));
          return h("select", {
            on: {
              "input": function input(e) {
                _this.boolDropdownChange(e.target.value, e);
              }
            },
            "class": "k-textbox"
          }, [booleanOptions]);

        default:
          return h("input", {
            "class": "k-textbox",
            domProps: {
              "value": value || ''
            },
            on: {
              "input": function input(e) {
                _this.inputChange(e.target.value, e);
              }
            }
          });
      }
    };

    return h("div", [this.$props.filterType !== 'boolean' && h("select", {
      on: {
        "change": function change(e) {
          _this.operatorChange(e.target.value, e);
        }
      },
      "class": "k-textbox"
    }, [optionMapper(this.$props.operators, ddlValue)]), filterComponent(this.$props.filterType, this.$props.value, this.$props.operators)]);
  };

  GridColumnMenuFilterCell.prototype.inputChange = function (value, e) {
    var filter = cellInputChange(value, e, this.$props);
    this.triggerChange(filter);
  };

  GridColumnMenuFilterCell.prototype.operatorChange = function (operatorValue, e) {
    var filter = cellOperatorChange(operatorValue, e, this.$props.value);
    this.triggerChange(filter);
  };

  GridColumnMenuFilterCell.prototype.boolDropdownChange = function (value, e) {
    value = value === '' ? '' : this.getBoolValue(value);
    var filter = cellBoolDropdownChange(value, e);
    this.triggerChange(filter);
  };

  GridColumnMenuFilterCell.prototype.getBoolValue = function (value) {
    return value === 'true' ? true : false;
  };

  GridColumnMenuFilterCell = __decorate([Component({
    props: {
      field: String,
      filterType: String,
      value: [Object, String, Number, Date, Boolean],
      operator: String,
      operators: Array
    }
  })], GridColumnMenuFilterCell);
  return GridColumnMenuFilterCell;
}(VueComponent);

export { GridColumnMenuFilterCell };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-vue-grid/dist/es/columnMenu/GridColumnMenuFilterCell.js
// module id = null
// module chunks = 